import { useParams } from "react-router-dom";

export default function HFEmbed({ type }) {
  const { id } = useParams();
  
  let src = "";
  if (type === "event") {
    if (id === "demo") {
      src = "https://kveventech-invite.hf.space/event/demo/";
    } else {
      src = `https://kveventech-invite.hf.space/event/${id}`;
    }
  } else if (type === "photos") {
    if (id === "demo") {
      src = "https://kveventech-gallery.hf.space/event/OKNZ";
    } else if (id === "admin") {
      src = "https://kveventech-gallery.hf.space/admin";
    } else {
      src = `https://kveventech-gallery.hf.space/event/${id}`;
    }
  } else if (type === "admin") {
    src = "https://kveventech-gallery.hf.space/admin";
  } else if (type === "ar") {
    src = `https://kveventech-ar.static.hf.space/${id}/index.html`;
  }

  return (
    <div className="fixed inset-0 w-full h-[100dvh] bg-black z-[9999]">
      <iframe 
        src={src} 
        className="w-full h-full border-0" 
        title={`${type} embed`}
        allow="camera; microphone; fullscreen; xr-spatial-tracking; gyroscope; accelerometer"
        allowFullScreen
      />
    </div>
  );
}
